import React from "react";
import { makeStyles } from "@mui/styles";
import { TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import FormControl from "@mui/material/FormControl";

const useStyles = makeStyles((theme) => ({
  datePicker: {
    "& .MuiInputBase-root": {
      backgroundColor: "rgba(255, 255, 255, 0.2)",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderTop: "none",
        borderRight: "none",
        borderLeft: "none",
        borderRadius: 0,
      },
      "&.Mui-focused fieldset": {
        borderTop: "none",
        borderRight: "none",
        borderLeft: "none",
        borderRadius: 0,
        borderWidth: 2,
      },
    },
  },
}));

const CustomDateDateField = ({
  margin,
  disabled,
  value,
  onChange,
  label,
  isValid,
  required,
}) => {
  const classes = useStyles();
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <FormControl fullWidth margin={margin} disabled={disabled}>
        <DatePicker
          value={value}
          format="DD/MM/YYYY"
          onChange={onChange}
          className={classes.datePicker}
          label={required ? `${label} *` : label} // Add * if required
          textField={<TextField error={!isValid} />}
        />
      </FormControl>
    </LocalizationProvider>
  );
};

export default CustomDateDateField;
